var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d22409;}.cls-2{fill:#fff;}.cls-3{fill:#e20613;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risorsa 47") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.5,
    cy: 55.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.5,
    cy: 55.5,
    r: 50.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.42,61.9l6.53-20a1.85,1.85,0,0,0-.23-1.6,1.82,1.82,0,0,0-1.4-.8l-49.1-3.3-1.61-7.79a1.84,1.84,0,0,0-1.8-1.46H24a1.84,1.84,0,1,0,0,3.67H34.31l6.46,31.17.18.75c.79,4.36,2.41,7.51,4.82,9.46A6.75,6.75,0,1,0,55.84,74.3H71.56a6.58,6.58,0,0,0-.73,3,6.75,6.75,0,1,0,6.74-6.74q-.34,0-.69,0H53.05c-3.2,0-6.63-.92-8.2-7.45H81.67A1.84,1.84,0,0,0,83.42,61.9ZM49.82,80.4a3.07,3.07,0,1,1,3.08-3.07A3.07,3.07,0,0,1,49.82,80.4Zm27.75,0a3.06,3.06,0,0,1-.34-6.1h.69a3.06,3.06,0,0,1-.35,6.1ZM84,48.15H76.09l.81-5.79,8.83.59Zm-40,11.35-1.59-7.68H49l1.08,7.68Zm8.63-7.68H60.4V59.5H53.77Zm-.51-3.67-1.06-7.52,9.28.62v6.9Zm11.9,3.67h7.79L70.79,59.5H64.08Zm0-3.67V41.5l9.15.61-.85,6Zm-16.7-7.77,1.09,7.77H41.7L40,39.88ZM74.5,59.5l1.08-7.68h7.26l-2.5,7.68Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.5a647cb9f3bddabed53dba786eb4e029.svg";
export { ForwardRef as ReactComponent };